import React from 'react'
import { Route, Router, Switch, NavLink } from 'react-router-dom'
import { createBrowserHistory } from 'history'
import { StateProvider } from '@State'
import { Toaster } from '@CommonComponents/toast'
import { QueueTab } from './QueueTab'
import { AssignedTab } from './AssignedTab'
import { SchoolsTab } from './SchoolsTab'

export const history = createBrowserHistory()

const BASE = '/account/billing_queue'

const initialState = {
  user: { isFinance: false },
  queue: [],
  assigned: [],
  assignedMeta: { total: 0, awaiting_payment: 0 },
  schools: [],
  schoolDetail: null,
  filters: { type: 'all', search: '' },
  loading: false,
}

const reducer = (state, action) => {
  switch (action.type) {
    case 'SET_USER':
      return { ...state, user: action.payload }
    case 'SET_QUEUE':
      return { ...state, queue: action.payload }
    case 'REMOVE_FROM_QUEUE':
      return { ...state, queue: state.queue.filter(item => item.id !== action.payload) }
    case 'SET_ASSIGNED':
      return {
        ...state,
        assigned: action.payload.items,
        assignedMeta: { total: action.payload.total, awaiting_payment: action.payload.awaiting_payment },
      }
    case 'UPDATE_ASSIGNED_ITEM':
      return {
        ...state,
        assigned: state.assigned.map(item =>
          item.id === action.payload.id ? action.payload : item
        ),
      }
    case 'SET_SCHOOLS':
      return { ...state, schools: action.payload }
    case 'SET_SCHOOL_DETAIL':
      return { ...state, schoolDetail: action.payload }
    case 'ADD_INVOICE_ACCOUNT':
      if (!state.schoolDetail) return state
      return {
        ...state,
        schoolDetail: {
          ...state.schoolDetail,
          invoice_accounts: [...state.schoolDetail.invoice_accounts, action.payload],
        },
      }
    case 'UPDATE_INVOICE_ACCOUNT':
      if (!state.schoolDetail) return state
      return {
        ...state,
        schoolDetail: {
          ...state.schoolDetail,
          invoice_accounts: state.schoolDetail.invoice_accounts.map(a =>
            a.id === action.payload.id ? { ...a, ...action.payload } : a
          ),
        },
      }
    case 'SET_FILTERS':
      return { ...state, filters: { ...state.filters, ...action.payload } }
    case 'SET_LOADING':
      return { ...state, loading: action.payload }
    default:
      return state
  }
}

const AppInner = () => {
  return (
    <div className="container-fluid mt-4">
      <div className="d-flex align-items-center justify-content-between mb-3">
        <h1 className="me-page-title mb-0">Billing Queue</h1>
      </div>

      <Router history={history}>
        <div className="tab-group">
          <div className="tab-list">
            <NavLink exact to={BASE + '/'} className="tab-button" activeClassName="active">
              Queue
            </NavLink>
            <NavLink to={BASE + '/assigned'} className="tab-button" activeClassName="active">
              Assigned
            </NavLink>
            <NavLink to={BASE + '/schools'} className="tab-button ml-auto" activeClassName="active">
              Schools
            </NavLink>
          </div>

          <div className="tab-panel">
            <Switch>
              <Route exact path={BASE + '/'} component={QueueTab} />
              <Route path={BASE + '/assigned'} component={AssignedTab} />
              <Route path={BASE + '/schools/:schoolId/accounts/:accountId'} component={SchoolsTab} />
              <Route path={BASE + '/schools/:schoolId'} component={SchoolsTab} />
              <Route path={BASE + '/schools'} component={SchoolsTab} />
              <Route component={QueueTab} />
            </Switch>
          </div>
        </div>
      </Router>
    </div>
  )
}

export const App = ({ initialData }) => {
  const state = {
    ...initialState,
    user: { isFinance: initialData ? initialData.isFinance : false },
  }

  return (
    <StateProvider initialState={state} reducer={reducer}>
      <Toaster />
      <AppInner />
    </StateProvider>
  )
}
